import React, { useEffect } from 'react';
import { View, Pressable, Text, Linking } from 'react-native';
import Icon from '../UI/icon/Icon';
import IconMap from '../UI/icon/IconMap';

import Footer from '../Footer';
import Splash from './Splash';
import Story from './Story';
import Services from './Services';
import Product from './Product';
import Partners from './Partners';
import Team from './Team';
import Transition from './Transition';
import Screens from '../../screens/Screens';
import { navStyles } from '../../navigation/AppNavigator';

const Home = (props) => {

	useEffect(() => {
		props.navigation.setOptions({
			headerLeft: () => {},
			headerRight: () => (
				<View style={navStyles.navButtonsContainer}>
					<Pressable
						style={navStyles.navButtonContainer}
						onPress={() => props.navigation.navigate(Screens.contact)}
					>
						<Text style={navStyles.navButtonText}>Contact</Text>
					</Pressable>
					<Pressable
						style={navStyles.navButtonContainer}
						onPress={async () => await Linking.openURL('https://portal.burncammedical.com')}
					>
						<Icon
							icon={IconMap.login}
							size={20}
						/>
						<Text style={navStyles.navButtonText}>Login</Text>
					</Pressable>
				</View>
			),
		});
	}, []);

	return (<>
		<Splash/>
		<Transition text='About Us'/>
		<Story/>
		<Transition text='Product'/>
		<Product/>
		<Transition text='Services'/>
		<Services/>
		<Transition text='Partners'/>
		<Partners/>
		<Transition text='Team'/>
		<Team/>
		<Footer {...props}/>
	</>);
};

export default Home;